import { useAxios } from "@/lib/hooks";

export interface MeResponse {
  user_id: string;
  email: string;
}

export const useAuthApi = () => {
  const { axiosInstance } = useAxios();

  const login = async (input: {
    email: string;
    password: string;
  }): Promise<MeResponse> => {
    const response = await axiosInstance.post<MeResponse>("/auth/login", input);

    return response.data;
  };

  const logout = async (): Promise<void> => {
    await axiosInstance.post("/auth/logout");
  };

  const refreshSession = async (): Promise<MeResponse> => {
    const response = await axiosInstance.post<MeResponse>("/auth/refresh");

    return response.data;
  };

  const createApiKey = async (): Promise<string> => {
    const response = await axiosInstance.post<{ api_key: string }>("/api-key");

    return response.data.api_key;
  };

  const sendPasswordResetEmail = async (input: {
    email: string;
  }): Promise<void> => {
    await axiosInstance.post("/auth/send-password-reset-email", input);
  };

  const resetPassword = async (input: {
    token: string;
    new_password: string;
  }): Promise<void> => {
    await axiosInstance.post("/auth/reset-password", input);
  };

  const changePassword = async (input: {
    old_password: string;
    new_password: string;
  }): Promise<void> => {
    await axiosInstance.post("/auth/change-password", input);
  };

  const acceptInvitation = async (input: {
    token: string;
    password: string | null;
  }): Promise<{
    brain_id: string;
  }> => {
    return (
      await axiosInstance.post<{
        brain_id: string;
      }>("/auth/accept-invitation", input)
    ).data;
  };

  return {
    login,
    logout,
    refreshSession,
    createApiKey,
    sendPasswordResetEmail,
    resetPassword,
    changePassword,
    acceptInvitation
  };
};
